import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { PrivateService } from 'app/core/services/private.service';

@Component({
  selector: 'dialog-leave',
  templateUrl: './dialog-leave.component.html',
  styleUrls: ['./dialog-leave.component.scss']
})
export class DialogLeaveComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<DialogLeaveComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private privateService: PrivateService,) { }

  ngOnInit(): void {
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  approveLeave(ramp_I_EmployeeLeave_ID: string) {
    this.privateService.approveLeave(ramp_I_EmployeeLeave_ID).subscribe((res) => {
      window.location.reload();
      this.dialogRef.close();
    }, (err) => {
      this.dialogRef.close();
    })
  }

  declineLeave(ramp_I_EmployeeLeave_ID: string) {
    this.privateService.declineLeave(ramp_I_EmployeeLeave_ID).subscribe((res) => {
      window.location.reload();
      this.dialogRef.close();
    }, (err) => {
      this.dialogRef.close();
    })
  }
}
